import { H1, VStack } from '@betterment/samba-react';
import { WorkflowLayout } from '@betterment/shared-components';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { PurposeCreationIntent } from '../../../../graphql/schema';
import Footer from '../../../../Shared/components-v2/footer/Footer';
import { NameAndImageForm } from '../../NameAndImageForm';
import { nameAndImage } from '../../sharedSchemas';
import { useMajorPurchaseStep } from '../FlowConfig';

type FormValues = Yup.InferType<typeof nameAndImage>;

export const MajorPurchaseNameAndImageStep: React.FC = () => {
  const navigate = useNavigate();
  const { flowId } = useParams<{ flowId: string }>();

  const { commit } = useMajorPurchaseStep('nameAndImage');

  const handleSubmit = (values: FormValues) => {
    commit(values);
    void navigate(`/add_purpose/major_purchase/${flowId}/target_details`);
  };

  return (
    <WorkflowLayout pageTitle={null}>
      <WorkflowLayout.Header workflowTitle="Choose a name and image for this goal" onClose={() => navigate('/')} />
      <WorkflowLayout.Content>
        <VStack css={{ gap: 'space.400' }}>
          <H1>Tell us about your goal.</H1>
          <NameAndImageForm handleSubmit={handleSubmit} intent={PurposeCreationIntent.MajorPurchase} />
        </VStack>
      </WorkflowLayout.Content>
      <WorkflowLayout.Footer>
        <Footer />
      </WorkflowLayout.Footer>
    </WorkflowLayout>
  );
};
